import { render } from "./ButtonStart.vue?vue&type=template&id=6f0b1420"
import script from "./ButtonStart.vue?vue&type=script&lang=js"
export * from "./ButtonStart.vue?vue&type=script&lang=js"

import exportComponent from "H:\\_LK\\workInProgress\\vue-pomodoro\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__